import { PieChart as PieChartRaw } from "@dive.tech/ui-graphs";

interface PieChartProps {
  data: any[];
  legendProps?: any;
  [key: string]: any;
}

const PieChart = ({ data, legendProps, ...otherProps }: PieChartProps) => {
  const enhancedLegendProps = {
    ...legendProps,
    textStyle: {
      fontFamily: "Manrope, sans-serif",
      fontSize: 12,
      fontWeight: 400,
      ...legendProps?.textStyle
    }
  };

  return (
    <PieChartRaw
      data={data}
      legendProps={enhancedLegendProps}
      {...otherProps}
    />
  );
};

export default PieChart;
